import React, { FC } from 'react';
import { useApolloClient, useMutation } from '@apollo/react-hooks';
import { displaySnackBar } from '../../../common/displaySnackbar';
import { IMPORT_ENSEIGNES } from '../../../graphql/enseigne/mutation';
import {
  ImportEnseignes,
  ImportEnseignesVariables,
} from '../../../graphql/enseigne/types/ImportEnseignes';
import { ImportEnseignesInputDatas } from '../../../types/graphql-global-types';
import CSVImportation, {
  IRawCSV,
} from '../../../common/components/CSVImportation/CSVImportation';

export const HEADERS = [
  'RESEAU (CROSS-ENSEIGNES)',
  'ENSEIGNE',
  'AGENCE',
  'SIRET AGENCE',
  'TELEPHONE AGENCE',
  'EMAIL AGENCE',
  'ADRESSE AGENCE',
  'CP AGENCE',
  'VILLE AGENCE',
  'Dirigeant',
  'Email Dirigeant',
  'Mobile Dirigeant',
];

export const reformatEnseigne = (
  rawData: IRawCSV<IEnseigneCSV>[],
): ImportEnseignesInputDatas[] => {
  return rawData.map(({ data }) => ({
    enseigneName: data['ENSEIGNE'],
    agencyName: data['AGENCE'],
    agencySiret: data['SIRET AGENCE'],
    agencyPhone: data['TELEPHONE AGENCE'],
    agencyEmail: data['EMAIL AGENCE'],
    agencyAdress: data['ADRESSE AGENCE'],
    agencyZipCode: data['CP AGENCE'],
    agencyTown: data['VILLE AGENCE'],
    managerName: data['Dirigeant'],
    managerEmail: data['Email Dirigeant'],
    managerPhone: data['Mobile Dirigeant'],
  }));
};

export interface IEnseigneCSV {
  'ADRESSE AGENCE': string;
  AGENCE: string;
  'CP AGENCE': string;
  Dirigeant: string;
  'EMAIL AGENCE': string;
  ENSEIGNE: string;
  'Email Dirigeant': string;
  'Mobile Dirigeant': string;
  'RESEAU (CROSS-ENSEIGNES)': string;
  'SIRET AGENCE': string;
  'TELEPHONE AGENCE': string;
  'VILLE AGENCE': string;
}

interface Params {
  handleClose(): void;
}

const CSVImportEnseignesModal: FC<Params> = (props) => {
  const { handleClose } = props;
  const client = useApolloClient();

  const [importCSVEnseignes, { loading }] = useMutation<
    ImportEnseignes,
    ImportEnseignesVariables
  >(IMPORT_ENSEIGNES, {
    onCompleted: (data) => {
      if (data) {
        if (data.importEnseignes === 0) {
          displaySnackBar(client, {
            type: 'INFO',
            message: `Aucune enseigne n'a été importée.`,
            isOpen: true,
          });
        } else {
          const enseignesCount = data.importEnseignes;
          displaySnackBar(client, {
            type: 'SUCCESS',
            message: `Les ${enseignesCount} enseignes ont été importées avec succès.`,
            isOpen: true,
          });
        }

        handleClose();
      }
    },
  });

  const handleImport = (datas: ImportEnseignesInputDatas[]) => {
    importCSVEnseignes({
      variables: {
        input: {
          datas,
        },
      },
    });
  };

  return (
    <CSVImportation<IEnseigneCSV>
      open={true}
      loading={loading}
      onImport={(data) => handleImport(reformatEnseigne(data))}
      headers={HEADERS}
      title="Importation d'enseignes"
      onClose={handleClose}
    />
  );
};

export default CSVImportEnseignesModal;
